import cn from 'classnames';
import { toPascalCase } from 'core-lib/utils/utils';
import { useRouter } from 'next/router';
import { VariantsListType } from 'src/modules/newCars/types';
import { trackVariantClicked } from 'src/modules/newCars/utils/events/variant';
import { Button, Typography } from 'ui';
import { ButtonVariants, Color, TypeScales } from 'ui/primitives';
import s from './VariantListingCard.module.scss';

type VariantCardType = {
  variantDetail: VariantsListType;
  modelName: string;
  modelImage: string;
  onVariantClick?: () => void;
  link: string;
};

export const VariantListingCard = ({
  variantDetail,
  modelName,
  modelImage,
  onVariantClick,
  link,
}: VariantCardType) => {
  const router = useRouter();

  function handleVariantClick() {
    if (onVariantClick) onVariantClick();
    trackVariantClicked();
  }
  function handleVariantRedirect() {
    router.push(link);
    trackVariantClicked();
  }
  return (
    <div className={s.variant} key={variantDetail?.variantName} aria-hidden>
      <div className={s.left} onClick={handleVariantClick}>
        <a href={link} style={{ pointerEvents: 'none' }} className={s.title}>
          <Typography
            label={`${variantDetail?.variantName}`}
            variant={TypeScales.h4}
            renderAs="SPAN"
          />
        </a>
        <div className={s.details}>
          <Typography
            label={toPascalCase(variantDetail?.fuelType)}
            color={Color.text_subheading}
            variant={TypeScales.body_para_r}
          />
          {variantDetail?.engine && <p className={s.dot} />}
          <Typography
            label={toPascalCase(variantDetail?.transmission)}
            color={Color.text_subheading}
            variant={TypeScales.body_para_r}
          />
          {variantDetail?.mileage && <p className={s.dot} />}
          <Typography
            label={variantDetail?.mileage}
            color={Color.text_subheading}
            variant={TypeScales.body_para_r}
          />
        </div>
        <div className={s.price_wrapper}>
          <Typography
            label={variantDetail?.price}
            variant={TypeScales.h4}
            className={s.price}
          />
          <Typography
            label="Starting price for new model"
            variant={TypeScales.small_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={cn(s.right, 'cmn_only_desktop')}>
        <div className={s.img}>
          <img
            src={variantDetail?.img || modelImage}
            alt={`${modelName}-image`}
          />
        </div>
        <Button
          label="View details"
          variant={ButtonVariants.ButtonLink}
          size="Small"
          onClick={() => {
            handleVariantRedirect();
          }}
        />
      </div>
    </div>
  );
};
